require("./sitio");
require("bootstrap");
require("@fancyapps/fancybox");

$(document).ready(function () {

    $("#mejoramiento .mejoramiento-img-slide").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    // Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.

    $('#mejoramiento .prev-btn').click(function() {
        $("#mejoramiento .mejoramiento-img-slide").slick('slickPrev');
    });

    $('#mejoramiento .next-btn').click(function() {
        $("#mejoramiento .mejoramiento-img-slide").slick('slickNext');
    });

    $("#lugar_especial .lugar-especial-img-slide").slick({
        autoplay: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $("#reparacion .reparacion-slide").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    // Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.

    $('#reparacion .next-btn').click(function() {
        $("#reparacion .reparacion-slide").slick('slickNext');
    });

    $("#mejorar-casas .mejorar-casa-slide").slick({
        autoplay: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    // Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.
    $('#mejorar-casa .next-btn').click(function() {
        $("#mejorar-casa .mejorar-casa-slide").slick('slickNext');
    });

    $('[data-fancybox="reparaciones"]').fancybox({
        // Otras opciones de configuración aquí
        loop: true, // Habilita el bucle de la galería
        slideShow: {
            autoStart: true, // Inicia la reproducción automática al abrir la galería
            speed: 2000 // Velocidad de reproducción automática en milisegundos (opcional)
        }
    });
});
